import { Typography } from '@mui/material';
import { Linking } from 'react';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import VideoModal from '../components/VideoModal';

function OurApp(){
	
	
	return (
    <div className='container' style={{ padding: "64px 1vw 64px 3vw" }}>
      <Typography variant="h4" component="h4" mb={4}>
      Our Android and iPhone App
      </Typography>
	  
	  <p>WFStudios Apps contains a splendid collection of unique and beautiful watchfaces that you can download on your watch.
			The watchfaces collection is constantly updated so you can find new watchfaces every time you open our App.</p>
		<br />	
			
		<h3>iPhone App for Amazfit GTR, GTS, T-rex series & Falcon, Cheetah, Balance, Active, Active Edge and more</h3>
		
		<div className='rating-video'>		
         <div className='rating'>
		<Link href="https://apps.apple.com/us/app/wfamazfit-watch-faces/id6473647228?itsct=apps_box_badge&amp;itscg=30200">
		  <Box
			component="img"
			sx={{ width: 200 , height: 100 }}
			alt="Download on the App Store"
			src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83&amp;releaseDate=1701907200"
		  />
		</Link>
		</div>
			<VideoModal title="Directy sync watch face with Amazfit Watches through WFAmazfit iPhone App" path="PPZHMS1JhUQ?si=m9vGZgXJ3L1uSGwv" />
		
		</div>
                
		<p>Beautiful collection watch faces for Amazfit, Zepp smart watch series such as Bip, GTR, GTS, T-Rex and Balance,Active, Cheetah, Falcon</p>
		<p>The application was created with the aim of making the watch more diverse and with the ability to change the watch faces daily.</p>
		<p>Currently supported languages - English, Spanish, Chinese, French, Italian, Polish, Portuguese, Russian, German, Turkish and Multilingual.</p>
		<br />
		<h3>Features</h3>
									<ul>
									
									<li>Simple instruction to download & install this Watch faces.</li>
									<li>Directly sync watch face with watch via bluetooth.</li>
									<li>Add your own watch face to watch.</li>
									<li>Add watch faces to favourites section</li>
									<li>Search by name or author name</li>
									<li>Watch faces are available in 15 different language.</li>	
									</ul>
		
		 
		<br />
		<br />	
		<h3>Android App for Amazfit GTR, GTS, T-rex series & Falcon, Cheetah, Balance, Active, Active Edge and more</h3>
		
		
        <div className='rating-video'>		
         <div className='rating'>
			<Link href="https://play.google.com/store/apps/details?id=com.ge.amazwatch">
			  <Box
				component="img"
				sx={{ width: 250 , height: 100 }}
				alt="Get it on Google Play"
				src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
			  />
			</Link>        
         </div>
			<VideoModal title="How to install custom watch faces for Amazfit GTR, GTS, T-rex series watches through Android App." path="MF5Ei23aB84?si=9WBKUYVZi5-IgeM3" />
		
		</div>
		<p>Watch faces divided into different categories like Animated,Weather, anime, analog, digital, technologies, simple, black, white, humour, sports, movies, holidays, childish and many more</p>
        <br />
		<h3>Features</h3>
									<ul>
									
									<li>Simple instruction to download & install the Watch faces.</li>
									<li>Easy to search, filter watch faces.</li>
									<li>Watch faces are available in 20 different language.</li>
									<li>Search by name and author name.</li>
									<li>Sort watch faces by download, like, view.</li>
									<li>Easy to make your own favourite list of watch face.</li>	
									</ul>
									
		

		<br />
		<br />
		<h3>Android App for Amazfit Bip series such as Bip, Bip S, Bip U/Pro, Bip 3/Pro, Bip 5 watch</h3>
		
		
         <div className='rating-video'>		
         <div className='rating'>
        <Link href="https://play.google.com/store/apps/details?id=com.ge.bipwatchface">
		  <Box
			component="img"
			sx={{ width: 250 , height: 100 }}
			alt="Get it on Google Play"
			src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
		  />
		</Link>  			   
		 </div>
			<VideoModal title="How to install custom watch faces for Amazfit Bip series watches through Android App." path="TpfKCBDlpxg?si=6YlWTUF1MBTD1IyI	" />
		
		</div>
                
		<br />
		<h3>Features</h3>
									<ul>
									
									<li>Easy to find & change watchface or dials.</li>
									<li>Watch face available in 10 different language.</li>
									<li>Simple instruction to download & sync watch face.</li>
									<li>Search dials by category, language, text.</li>
									<li>Download & Favourite watch face section to easily find old dials.</li>
									<li>Directly sync watch face to watch via bluetooth.</li>	
									</ul>
		
        
    </div>
	);
}
export default OurApp